import * as React from 'react';

export default class ChartErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[NvChart] Render error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return <p className='h--smaller mb-4'>Chart failed to render.</p>;
    }
    return this.props.children;
  }
}
